import { Content } from '@pushwoosh/rpc-service-client/pushwoosh/channels/messagingApi/v2/payload_pb';

export type ChannelsExportClasses = {
  MessagingApiContent: typeof Content;
};

export const channels: ChannelsExportClasses = {
  MessagingApiContent: Content,
};
